var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"color":"transparent"}},[_c('v-main',[_c('TheHeader'),_c('v-container',{staticStyle:{"margin":"0px","padding":"0px","min-width":"100%","scroll-snap-type":"y mandatory"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }